import Vue from 'vue'
import VueRouter from 'vue-router'
import Page from  '../views/home-page/home-page'

//二级路由
import HomePage from '../views/children-page/children-home-page/children-home-page'
import ProductsPage from '../views/children-page/products-page/products-page'
import SolutionPage from '../views/children-page/solution-page/solution-page'
import CasesPage from '../views/children-page/cases-page/cases-page'
import AboutPage from '../views/children-page/about-page/about-page'
import ProductsInfoPage from '../views/children-page/products-info-page/products-info-page'
import ProductsBuyPage from '../views/children-page/products-buy-page/products-buy'
//三级路由
import SolutionSchoolPage from '../views/children-page/solution-page/childrenBlock/products-school-page/products-school-page'
import SolutionEnvironmentPage from '../views/children-page/solution-page/childrenBlock/solution-environment-page/solution-environment-page'
import SolutionAdministrationPage from '../views/children-page/solution-page/childrenBlock/solution-administration-page/solution-administration-page'
import SolutionChemicalIndustryPage from '../views/children-page/solution-page/childrenBlock/solution-chemical-industry-page/solution-chemical-industry-page'
import SolutionConstructionPage from '../views/children-page/solution-page/childrenBlock/solution-construction-page/solution-construction-page'
import SolutionAgriculturePage from '../views/children-page/solution-page/childrenBlock/solution-agriculture-page/solution-agriculture-page'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home',
        component: Page,
    },{
        path: '/home',
        component: Page,
        meta: {
            index: 0
        },
        children:[
            {
                path:'',
                component: HomePage
            },
            {
                path:'/page/products',
                name:'products',
                component: ProductsPage,
                meta: {
                    index: 5
                },
            },
            {
                path:'/page/products-info',  //产品详情
                name:'more',
                component: ProductsInfoPage,
                meta: {
                    index: 1
                },
            },
            {
                path:'/page/products-buy',  //购买询问
                name:'buy',
                component: ProductsBuyPage,
                meta: {
                    index: 1
                },
            },
            {
                path:'/page/solution',
                component: SolutionPage,
                children:[
                    {
                        path:'/page/solution/school', //校园
                        component: SolutionSchoolPage,
                        meta: {
                            index: 6
                        },
                    },
                    {
                        path:'/page/solution/environment', //环保
                        component: SolutionEnvironmentPage,
                        meta: {
                            index: 6
                        },
                    },
                    {
                        path:'/page/solution/administration', //城管
                        component: SolutionAdministrationPage,
                        meta: {
                            index: 6
                        },
                    },
                    {
                        path:'/page/solution/chemical-industry', //化工
                        component: SolutionChemicalIndustryPage,
                        meta: {
                            index: 6
                        },
                    },
                    {
                        path:'/page/solution/construction', //工地
                        component: SolutionConstructionPage,
                        meta: {
                            index: 6
                        },
                    },
                    {
                        path:'/page/solution/agriculture', //农业
                        component: SolutionAgriculturePage,
                        meta: {
                            index: 6
                        },
                    },
                ]
            },
            {
                path:'/page/cases',
                component: CasesPage,
                meta: {
                    index: 7
                },
            },
            {
                path:'/page/about',
                component: AboutPage,
                meta: {
                    index: 7
                },
            },
        ]

    }

]

const router = new VueRouter({
  routes
})

export default router
